import React from 'react';

/***********************
  Menu Component
 ***********************/

export const Menu = ({ showMenu, toggleMenu }) => {
  return (
    <div className={`menu-container ${showMenu}`}>
      <div className="overlay" />
      <div className="menu-items">
        <ul>
          <li>
            <a href="/#welcome-section" onClick={toggleMenu}>
              HOME
            </a>
          </li>
          <li>
            <a href="/#about" onClick={toggleMenu}>
              ABOUT
            </a>
          </li>
          <li>
            <a href="/#projects" onClick={toggleMenu}>
              PORTFOLIO
            </a>
          </li>
          <li>
            <a href="/#contact" onClick={toggleMenu}>
              CONTACT
            </a>
          </li>
          <li>
            <a href="/blog" onClick={toggleMenu}>
              BLOG
            </a>
          </li>
          <li>
            <a href="/archive/2024/uoh/soupbg" onClick={toggleMenu}>
              ARCHIVE
            </a>
          </li>
        </ul>
        <SocialLinks />
      </div>
    </div>
  );
};

/***********************
  Nav Component
 ***********************/

export const Nav = ({ showMenu, toggleMenu }) => {
  return (
    <nav id="navbar">
      <div className="nav-wrapper">
        <p className="brand">
          Dhanush
          <strong>SR Kenkiri</strong>
        </p>
        <button
          onClick={toggleMenu}
          className={showMenu === 'active' ? 'menu-button active' : 'menu-button'}
          aria-label="Toggle menu"
        >
          <span />
        </button>
      </div>
    </nav>
  );
};

/***********************
  Header Component
 ***********************/

export const Header = () => {
  return (
    <header id="welcome-section">
      <div className="forest" />
      <div className="silhouette" />
      <div className="moon" />
      <div className="container">
        <h1>
          <span className="line">I do</span>
          <span className="line">graphic design</span>
          <span className="line">
            <span className="color">&</span> code.
          </span>
        </h1>
        <div className="buttons">
          <a href="#projects">my portfolio</a>
          <a href="#contact" className="cta">
            get in touch
          </a>
        </div>
      </div>
    </header>
  );
};

/***********************
  About Component
 ***********************/

export const About = () => {
  return (
    <section id="about">
      <div className="wrapper">
        <article>
          <div className="title">
            <h3>Who's this guy?</h3>
            <p className="separator" />
          </div>
          <div className="desc full">
            <h4 className="subtitle">My name is Dhanush.</h4>
            <p>
              I am a web developer and UX designer based in the beautiful North Side of Bengaluru,
              India.
            </p>
            <p>
              I really enjoy solving problems as well as making things pretty and easy to use. I
              can't stop learning new things; the more, the better. I also love photography, a hobby
              I'm taking along since the good old film cameras.
            </p>
          </div>
          <div className="title">
            <h3>What does he do?</h3>
            <p className="separator" />
          </div>
          <div className="desc">
            <h4 className="subtitle">I'm a programmer.</h4>
            <p>
              For the front-end I usually work with Javascript, either standalone or including
              popular frameworks like ReactJS and VueJS. I also make the web pretty by using Sass,
              CSS and, whenever needed, any of their friends: Bootstrap, Bulma, etc.
            </p>
            <p>
              For the back-end I also work with Javascript (NodeJS, Express, MongoDB, etc). But, of
              course, whenever the project requires PHP, I do PHP as well (Wordpress, Laravel, etc).
            </p>
          </div>
          <div className="desc">
            <h4 className="subtitle">Also a designer.</h4>
            <p>
              I feel comfortable working with many Adobe products. Photoshop, Illustrator, InDesign,
              Lightroom or Xd are some kind of industry standards and I love working with them. I'm
              not limited to them, though: Gimp, Inkscape or Figma are also very valid applications
              that I've been working with.
            </p>
            <p>
              User interfaces, brochures, books, branding... You name it! As I mentioned, creating
              pretty things is particularly important for me.
            </p>
          </div>
        </article>
      </div>
    </section>
  );
};

/***********************
  Project Component
 ***********************/

export const Project = ({ title, img, tech, link, repo, children }) => {
  const techIcons = {
    sass: 'fab fa-sass',
    css: 'fab fa-css3-alt',
    js: 'fab fa-js-square',
    react: 'fab fa-react',
    vue: 'fab fa-vuejs',
    d3: 'far fa-chart-bar',
    node: 'fab fa-node'
  };

  return (
    <div className="project">
      <a className="project-link" href={link} target="_blank" rel="noopener noreferrer">
        <img className="project-image" src={img} alt={'Screenshot of ' + title} />
      </a>
      <div className="project-details">
        <div className="project-tile">
          <p className="icons">
            {tech.split(' ').map(t => (
              <i className={techIcons[t]} key={t} />
            ))}
          </p>
          {title}{' '}
        </div>
        {children}
        <div className="buttons">
          <a href={repo} target="_blank" rel="noopener noreferrer">
            View source <i className="fas fa-external-link-alt" />
          </a>
          <a href={link} target="_blank" rel="noopener noreferrer">
            Try it Live <i className="fas fa-external-link-alt" />
          </a>
        </div>
      </div>
    </div>
  );
};

/***********************
  Projects Component
 ***********************/

export const Projects = () => {
  return (
    <section id="projects">
      <div className="projects-container">
        <div className="heading">
          <h3 className="title">My Works</h3>
          <p className="separator" />
          <p className="subtitle">
            Here's a list of <u>most</u> of the projects I've been working on lately.
          </p>
        </div>
        <div className="projects-wrapper">
          <Project
            title="IndiaCodex Hackathon '25 - Winner 🏆"
            img={'https://raw.githubusercontent.com/DhanushKenkiri/IndiaCodexHackathon--25-Submission/main/preview.png'}
            tech="node"
            link="https://github.com/DhanushKenkiri/IndiaCodexHackathon--25-Submission"
            repo="https://github.com/DhanushKenkiri/IndiaCodexHackathon--25-Submission"
          >
            <small>Built using Python - MIT License.</small>
            <p>🏆 Hackathon winning project! An innovative solution developed for IndiaCodex Hackathon 2025 showcasing cutting-edge technology.</p>
          </Project>

          <Project
            title="Cardano Hackathon '25 Submission"
            img={'https://raw.githubusercontent.com/DhanushKenkiri/CardanoHackathon-25-Submission/main/public/preview.png'}
            tech="js react node"
            link="https://github.com/DhanushKenkiri/CardanoHackathon-25-Submission"
            repo="https://github.com/DhanushKenkiri/CardanoHackathon-25-Submission"
          >
            <small>Built using TypeScript, React, and Cardano blockchain integration.</small>
            <p>Hackathon submission for Cardano Asia '25 - A decentralized application showcasing blockchain capabilities with 1 star.</p>
          </Project>

          <Project
            title="Uniicon - Avalanche Hackathon"
            img={'https://raw.githubusercontent.com/DhanushKenkiri/Uniicon-AvalancheHackthon/main/preview.png'}
            tech="js react node"
            link="https://github.com/DhanushKenkiri/Uniicon-AvalancheHackthon"
            repo="https://github.com/DhanushKenkiri/Uniicon-AvalancheHackthon"
          >
            <small>Built using JavaScript and blockchain technology.</small>
            <p>Decentralized platform built for Avalanche Hackathon showcasing Web3 capabilities with 1 star and 1 fork on GitHub.</p>
          </Project>

          <Project
            title="Quantum-Masumi AI Platform"
            img={'https://raw.githubusercontent.com/DhanushKenkiri/Quantum-Masumi/main/preview.png'}
            tech="js node"
            link="https://github.com/DhanushKenkiri/Quantum-Masumi"
            repo="https://github.com/DhanushKenkiri/Quantum-Masumi"
          >
            <small>Advanced AI and quantum computing integration project.</small>
            <p>Innovative platform exploring the intersection of quantum computing and artificial intelligence for next-gen solutions.</p>
          </Project>

          <Project
            title="StudyAlte - Learning Platform"
            img={'https://raw.githubusercontent.com/DhanushKenkiri/StudyAlte/main/preview.png'}
            tech="js react"
            link="https://github.com/DhanushKenkiri/StudyAlte"
            repo="https://github.com/DhanushKenkiri/StudyAlte"
          >
            <small>Built using TypeScript for modern education solutions.</small>
            <p>An alternative study platform designed to enhance learning experiences with interactive features and modern UI.</p>
          </Project>

          <Project
            title="Project-EcoFinds"
            img={'https://raw.githubusercontent.com/DhanushKenkiri/Project-EcoFinds/main/preview.png'}
            tech="js react"
            link="https://github.com/DhanushKenkiri/Project-EcoFinds"
            repo="https://github.com/DhanushKenkiri/Project-EcoFinds"
          >
            <small>Built using TypeScript for environmental sustainability.</small>
            <p>Eco-friendly product discovery platform helping users find sustainable alternatives and make environmentally conscious choices.</p>
          </Project>

          <Project
            title="Sentra-Native Mobile App"
            img={'https://raw.githubusercontent.com/DhanushKenkiri/sentra-native/main/preview.png'}
            tech="js react"
            link="https://github.com/DhanushKenkiri/sentra-native"
            repo="https://github.com/DhanushKenkiri/sentra-native"
          >
            <small>Built with React Native for cross-platform mobile development.</small>
            <p>Native mobile application providing seamless user experience across iOS and Android platforms with modern features.</p>
          </Project>

          <Project
            title="AdverseSensor - IoT Monitoring"
            img={'https://raw.githubusercontent.com/DhanushKenkiri/AdverseSensor/main/preview.png'}
            tech="node"
            link="https://github.com/DhanushKenkiri/AdverseSensor"
            repo="https://github.com/DhanushKenkiri/AdverseSensor"
          >
            <small>Built using Dart - MIT License.</small>
            <p>IoT-based sensor monitoring system for detecting adverse environmental conditions and providing real-time alerts.</p>
          </Project>

          <Project
            title="Project-NVK Analyzer"
            img={'https://raw.githubusercontent.com/DhanushKenkiri/Project-NVK_Analyzer/main/preview.png'}
            tech="js node"
            link="https://github.com/DhanushKenkiri/Project-NVK_Analyzer"
            repo="https://github.com/DhanushKenkiri/Project-NVK_Analyzer"
          >
            <small>Built using JavaScript for data analysis.</small>
            <p>Advanced data analyzer tool with 1 star on GitHub, designed for comprehensive data processing and visualization.</p>
          </Project>

          <Project
            title="Wifi-Attendance System"
            img={'https://raw.githubusercontent.com/DhanushKenkiri/Wifi-Attendance/main/preview.png'}
            tech="js node"
            link="https://github.com/DhanushKenkiri/Wifi-Attendance"
            repo="https://github.com/DhanushKenkiri/Wifi-Attendance"
          >
            <small>Built using JavaScript - Apache License 2.0.</small>
            <p>Automated attendance tracking system using WiFi network detection for seamless student attendance management.</p>
          </Project>

          <Project
            title="Parkngo - Smart Parking Solution"
            img={'https://raw.githubusercontent.com/DhanushKenkiri/Parkngo/main/preview.png'}
            tech="node"
            link="https://github.com/DhanushKenkiri/Parkngo"
            repo="https://github.com/DhanushKenkiri/Parkngo"
          >
            <small>Built using Python for backend processing.</small>
            <p>Smart parking management system to help users find and book parking spots efficiently in urban areas.</p>
          </Project>

          <Project
            title="Medi-Bridge Healthcare Platform"
            img={'https://raw.githubusercontent.com/DhanushKenkiri/Medi-Bridge/main/preview.png'}
            tech="node"
            link="https://github.com/DhanushKenkiri/Medi-Bridge"
            repo="https://github.com/DhanushKenkiri/Medi-Bridge"
          >
            <small>Built using Python for healthcare data management.</small>
            <p>A healthcare bridge platform connecting patients with medical services and records management systems.</p>
          </Project>

          <Project
            title="ConorProtocol - P2P Contract Sharing"
            img={'https://raw.githubusercontent.com/DhanushKenkiri/ConorProtocol/main/preview.png'}
            tech="js node"
            link="https://github.com/DhanushKenkiri/ConorProtocol"
            repo="https://github.com/DhanushKenkiri/ConorProtocol"
          >
            <small>Built using JavaScript for peer-to-peer networking.</small>
            <p>Peer-to-peer immutable contract sharing protocol for decentralized document management and verification.</p>
          </Project>
        </div>
      </div>
    </section>
  );
};

/***********************
  Contact Component
 ***********************/

export const Contact = () => {
  return (
    <section id="contact">
      <div className="container">
        <div className="heading-wrapper">
          <div className="heading">
            <p className="title">
              Want to <br />
              contact me?
            </p>
            <p className="separator" />
            <p className="subtitle">
              Please, use the form below or send an email to {''}
              <span className="mail">
                web
                <i className="fas fa-at at" />
                Dhanush SR Kenkiri
                <i className="fas fa-circle dot" />
                com
              </span>
              :
            </p>
          </div>
          <SocialLinks />
        </div>
        <form id="contact-form" action="#">
          <input placeholder="Name" name="name" type="text" required />
          <input placeholder="Email" name="email" type="email" required />
          <textarea placeholder="Message" type="text" name="message" />
          <input className="button" id="submit" value="Submit" type="submit" />
        </form>
      </div>
    </section>
  );
};

/***********************
  Footer Component
 ***********************/

export const Footer = () => {
  return (
    <footer>
      <div className="wrapper">
        <h3>THANKS FOR VISITING</h3>
        <p>© 2020 - {new Date().getFullYear()} Made with 🧡 - DSRK</p>
        <SocialLinks />
      </div>
    </footer>
  );
};

/***********************
  Social Links Component
 ***********************/

export const SocialLinks = () => {
  return (
    <div className="social">
      <a
        href="https://twitter.com/yagoestevez"
        target="_blank"
        rel="noopener noreferrer"
        title="Link to author's Twitter profile"
      >
        {' '}
        <i className="fab fa-twitter" />
      </a>
      <a
        id="profile-link"
        href="https://github.com/yagoestevez"
        target="_blank"
        rel="noopener noreferrer"
        title="Link to author's GitHub Profile"
      >
        {' '}
        <i className="fab fa-github" />
      </a>
      <a
        href="https://codepen.io/yagoestevez"
        target="_blank"
        rel="noopener noreferrer"
        title="Link to author's Codepen Profile"
      >
        {' '}
        <i className="fab fa-codepen" />
      </a>
    </div>
  );
};
